import type { RunProjection } from "@roboscientist/contracts";

export const isRunningRun = (run: RunProjection): boolean => /^(?:active|running)$/i.test(run.status);

export const runStart = (run: RunProjection): number => Date.parse(run.startedAt ?? run.updatedAt);

export const runEnd = (run: RunProjection, now: number = Date.now()): number => {
  if (run.completedAt) return Date.parse(run.completedAt);
  return isRunningRun(run) ? now : Date.parse(run.updatedAt);
};

export const runDuration = (run: RunProjection, now: number = Date.now()): number =>
  Math.max(0, runEnd(run, now) - runStart(run));
